export default __webpack_public_path__ + "static/media/name.2642f1af.png";